import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconGutterHorizontal16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconGutterHorizontal16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.5 3a.5.5 0 0 0 0-1H13a2 2 0 0 0-2 2v7.998a2 2 0 0 0 2 2h.5a.5.5 0 1 0 0-1H13a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM8 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 4m-5.998 9.498a.5.5 0 0 1 .5-.5H3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-.498a.5.5 0 1 1 0-1H3a2 2 0 0 1 2 2v7.998a2 2 0 0 1-2 2h-.498a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconGutterHorizontal16);
